import layout from '@/layout'

export default {
  path: '/advance_fund',
  component: layout,
  redirect: '/advance_fund/index',
  name: 'advance_fund_index',
  meta: {
    title: 'advance_fund',
    icon: 'el-icon-document'
  },
  children: [
    {
      path: '/advance_fund/index',
      name: 'advance_fund_index',
      component: () => import('@/views/advance_fund/index'),
      meta: {
        title: 'advance_fund_index',
        icon: 'el-icon-document'
      }
    }
  ]
}
